import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useAppSelector } from '@redux/hooks';
import { selectRegion } from '@redux/slices/header';
import { Region } from '@enums/RegionList';

export const WeatherAlertImport = dynamic(() => import('./WeatherAlert'), { ssr: true });

export const WeatherAlert = () => {
  const router = useRouter();
  const { REGION: regionId } = useAppSelector(selectRegion);

  if (router.route !== '/' || +regionId !== Region.Moscow) {
    return null;
  }

  return <WeatherAlertImport />;
};
